import React, { useEffect } from "react";

import locationIcon from "../assets/images/icon-green-location.svg";
import emailIcon from "../assets/images/icon-green-mail.svg";
import phoneIcon from "../assets/images/icon-green-phone.svg";
import hoursIcon from "../assets/images/icon-green-hour.svg";
import { Helmet } from "react-helmet-async";

export default function Contact() {

  useEffect(() => {
    window.scrollTo(0, 0);

    // Reinitialize WOW animations if used
    if (window.WOW) new window.WOW().init();

    // Reinitialize Magic Cursor on page load if your theme uses it
    if (window.cursor && window.cursor.destroy) window.cursor.destroy();
    if (window.MouseFollower) window.cursor = new window.MouseFollower();
  }, []);


  return (
    <>
    <Helmet>
  <title>Contact BrightLife Physio Point | Book Appointment</title>
  <meta
    name="description"
    content="Contact BrightLife Physio Point in Hyderabad to book physiotherapy and rehabilitation appointments."
  />
</Helmet>
     <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Contact Us
                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Page Contact Start */}
      <div className="page-contact">
        <div className="container">
          <div className="row">

            {/* Location */}
            <div className="col-lg-3 col-md-6">
              <div className="contact-info-item wow fadeInUp">
                <div className="icon-box">
                  <img loading="lazy" src={locationIcon} alt="location" />
                </div>
                <div className="contact-info-content">
                  <h3>location</h3>
                  <p>In Game point hi-tech premises, sidhi vinayak nagar Madhapur, </p>
                  <p>behind Meridian School, HITEC City, Hyderabad, Telangana 500081</p>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-3 col-md-6">
              <div className="contact-info-item wow fadeInUp" data-wow-delay="0.25s">
                <div className="icon-box">
                  <img loading="lazy" src={emailIcon} alt="email" />
                </div>
                <div className="contact-info-content">
                  <h3>email</h3>
                  <p>brightlifephysio@gmail.com</p>
                  <p>contact@brightlifephysio.com</p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="col-lg-3 col-md-6">
              <div className="contact-info-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="icon-box">
                  <img loading="lazy" src={phoneIcon} alt="phone" />
                </div>
                <div className="contact-info-content">
                  <h3>phone</h3>
                  <p>090006 66889</p>
                </div>
              </div>
            </div>

            {/* Working Hours */}
            <div className="col-lg-3 col-md-6">
              <div className="contact-info-item wow fadeInUp" data-wow-delay="0.75s">
                <div className="icon-box">
                  <img loading="lazy" src={hoursIcon} alt="hours" />
                </div>
                <div className="contact-info-content">
                  <h3>working hours</h3>
                  <p>Mon – Sat : 10:00 AM – 8:00 PM</p>
                  <p>Sunday : Closed</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* Page Contact End */}

      {/* Google Map Start */}
      <div className="google-map">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="google-map-iframe">
               
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.098844832103!2d78.3854834!3d17.4549825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91981103d02d%3A0x59bebadb2449ad17!2sBright%20Life%20-Dr.Bhargava*2ADr.VishwaSruthi!5e0!3m2!1sen!2sin!4v1765367250530!5m2!1sen!2sin"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Google Map End */}
    </>
  );
}
